import { assign, mapKeys } from 'lodash';
import { TreeNode, TreeNodeProps } from '../../lib/tree-node';
export default class TreeItemViewController {
  static $inject = ['$element'];

  private props: TreeNodeProps;
  private key: string;
  private name: string;
  private icon: string;
  private disabled: boolean;
  private nodes: TreeNode[];
  private expanded = false;
  private selected = false;
  private onSelect: ($args: { $key: string }) => void;

  constructor(private $element) {}

  $onInit = () => {
    const attrs = assign({}, this.props);
    const $item = this.$element.children().length ? this.$element.children().first() : this.$element;

    TreeItemViewController.spreadPropsToDataAttributes(attrs, $item);
  };

  turn() {
    this.expanded = !this.expanded;
  }

  select(key = this.key) {
    if (!this.disabled) {
      this.onSelect({ $key: key });
    }
  }

  hasChildren() {
    return this.nodes && this.nodes.length;
  }

  handleChildTreeSelection($key) {
    this.select($key);
  }

  isContinuous(iconKey: unknown) {
    if (typeof iconKey === 'string') {
      return iconKey.endsWith('range');
    }
    return false;
  }

  static spreadPropsToDataAttributes(props: TreeNodeProps, $elem) {
    $elem.attr(propsToDataAttrs(props));
  }
}

function propsToDataAttrs(source: TreeNodeProps) {
  return mapKeys(source, (value, key: string) => `data-${key.toLowerCase()}`);
}
